<template>
  <section>
    <base-toaster
      :open="toasterIsOpen"
      @close="hideDialog"
    >
      <div class="flex justify-between items-center">
        <font-awesome-icon
          class="ml-3"
          icon="fa-solid fa-thumbs-up "
          size="lg"
        />

        <h4>Request submitted successfully!</h4>
        <button
          class="btn btn-outline"
          @click="hideDialog"
        >
          <font-awesome-icon
            icon="fa-regular fa-circle-xmark"
            size="2x"
          />
        </button>
      </div>
    </base-toaster>
    <div
      v-if="show"
      id="deleteModal"
    >
      <div class="fixed z-40 h-full inset-0 opacity-25 bg-black" />
      <div
        class="
          fixed
          overflow-x-hidden overflow-y-auto
          inset-0
          flex
          justify-center
          items-center
          z-50
        "
      >
        <div
          class="relative px-4 w-full max-w-3xl 2xl:max-w-5xl h-auto md:h-auto"
        >
          <div
            class="
              relative
              bg-white
              p-6
              w-full
              flex flex-col
              rounded-lg
              shadow
              dark:bg-gray-700
            "
          >
            <base-spinner v-if="isLoading" />
            <!-- Modal header -->
            <div class="flex justify-end p-2">
              <button
                type="button"
                class="
                  text-gray-400
                  bg-transparent
                  hover:bg-gray-200 hover:text-gray-900
                  rounded-lg
                  text-sm
                  p-1.5
                  ml-auto
                  inline-flex
                  items-center
                  dark:hover:bg-gray-800 dark:hover:text-white
                "
                @click="close"
              >
                <svg
                  class="w-8 h-8"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
              </button>
            </div>
            <!-- Modal body -->
            <div class="p-6 pt-0 text-center">
              <svg
                class="mx-auto mb-4 w-14 h-14 text-gray-400 dark:text-gray-200"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <h2 class="mb-5 text-2xl dark:text-gray-400">
                Explain why you would like to remove this protein
                {{ uniprotId }} from the context of condensate {{ canonicalId }}.
              </h2>
              <textarea
                id="funComment"
                v-model.trim="comment"
                class="
                  form-control
                  block
                  px-3
                  py-1.5
                  text-base
                  font-normal
                  text-gray-700
                  bg-white bg-clip-padding
                  border border-solid border-gray-300
                  rounded
                  transition
                  ease-in-out
                  m-0
                  focus:text-gray-700
                  focus:bg-white
                  focus:border-blue-600
                  focus:outline-none
                "
                rows="5"
                placeholder="Please provide evidence/PubMed ID."
                @keyup="validateComment"
              />

              <p
                v-if="message && error"
                :class="
                  error ? 'text-danger font-bold' : 'text-success font-bold'
                "
              >
                {{ message }}
              </p>

              <button
                type="button"
                class="
                  text-white
                  bg-blue-500
                  hover:bg-blue-700
                  focus:ring-2 focus:ring-blue-300
                  rounded-lg
                  inline-flex
                  items-center
                  px-5
                  py-2.5
                  text-center
                  mr-2
                "
                @click="deleteUniprotIdReq"
              >
                Confirm
              </button>
              <button
                type="button"
                class="
                  bg-white
                  hover:bg-gray-200
                  focus:ring-2 focus:ring-gray-300
                  rounded-lg
                  border border-gray-200
                  px-5
                  py-2.5
                  hover:text-gray-900
                  focus:z-10
                  dark:bg-gray-700
                  dark:text-gray-300
                  dark:border-gray-500
                  dark:hover:text-white
                  dark:hover:bg-gray-600
                "
                @click="close"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import BaseSpinner from './BaseSpinner.vue';
import BaseToaster from './BaseToaster.vue';
const _ = require('lodash');
let host = require('../js/const').apiHost;
export default {
  components: { BaseToaster, BaseSpinner },
  props: ['show', 'title', 'uniprotId', 'canonicalId'],
  data() {
    return {
      comment: '',
      message: '',
      error: false,
      toasterIsOpen: false,
      isLoading: false,
    };
  },
  computed: {
    jwt: function () {
      return this.$store.getters['User/jwt'];
    },
    role: function () {
      return this.$store.getters['User/userRole'];
    },
  },
  methods: {
    showDialog() {
      this.toasterIsOpen = true;
    },
    hideDialog() {
      this.toasterIsOpen = false;
    },
    validateComment() {
      this.message = '';
    },
    confirm() {
      this.$emit('confirm');
    },
    close() {
      this.$emit('cancel');
    },
    async deleteUniprotIdReq() {
      const vm = this;

    

      if (vm.isDev) {
        host = require('../js/const').devApiHost;
      }

      let url = `${host}/api/update-items`;
      let data;

      if (vm.comment === '') {
        this.error = true;
        vm.message = `Enter a reason for such request. It should not be empty!`;
        return;
      }
      data = {
        Entity: 'condensate',
        EntityId: vm.canonicalId,
        ChangeOperation: 'remove',
        Attribute: 'proteins',
        Value: vm.uniprotId,
        SubmissionComments: this.comment,
        Status: 'requested',
      };

      this.error = false;
      vm.message = '';

      this.isLoading = true;
      try {
        await this.axios.post(
          url,
          { data: data },
          {
            headers: {
              Authorization: `Bearer ${this.jwt}`,
            },
          }
        );
        this.isLoading = false;
        this.toasterIsOpen = true;

        this.$emit('update-key');
        setTimeout(() => {
          this.toasterIsOpen = false;
        }, 2000);

        this.comment = '';
      } catch (e) {
       
        this.isLoading = false;
        this.error = true;
        this.message =
          e.message || 'Something went wrong, please try again later!';
      }
    },
  },
};
</script>

<style></style>
